import { DialogComponent } from '@theme/dialog';

/**
 * A custom element that manages a size guide drawer.
 *
 * @extends {DialogComponent}
 */
class SizeGuideComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
  }

  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('size-guide-component')) {
  customElements.define('size-guide-component', SizeGuideComponent);
}